import { render, staticRenderFns } from "./FormularioCliente.vue?vue&type=template&id=3f27b253&"
import script from "./FormularioCliente.vue?vue&type=script&lang=ts&"
export * from "./FormularioCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports